import {Component, OnChanges, SimpleChanges} from '@angular/core';
import {CapitalCasePipe} from "../../../../pipes/capital-case.pipe";
import {DxButtonComponent, DxDataGridComponent, DxFormComponent, DxTemplateDirective} from "devextreme-angular";
import {
    DxiButtonComponent,
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent, DxoFilterRowComponent, DxoHeaderFilterComponent, DxoLoadPanelComponent, DxoPagerComponent, DxoPagingComponent,
    DxoScrollingComponent, DxoSortingComponent, DxoToolbarComponent
} from "devextreme-angular/ui/nested";
import {UserAvatarEmailComponent} from "../../../../components/utils/user-avatar-email/user-avatar-email.component";
import {TimeOffRequestsComponent} from "../time-off-requests.component";
import {LeaveOfAbsenceGridViewDto} from "@services";
import {NgClass} from "@angular/common";
import {AbsencePopupComponent} from "./absence-popup/absence-popup.component";
import {TimeOffFilterPanelComponent} from "../time-off-filter-panel/time-off-filter-panel.component";

@Component({
  selector: 'app-absences',
    imports: [
        CapitalCasePipe,
        DxButtonComponent,
        DxDataGridComponent,
        DxTemplateDirective,
        DxiButtonComponent,
        DxiColumnComponent,
        DxiItemComponent,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoFilterRowComponent,
        DxoHeaderFilterComponent,
        DxoLoadPanelComponent,
        DxoPagerComponent,
        DxoPagingComponent,
        DxoScrollingComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        UserAvatarEmailComponent,
        NgClass,
        AbsencePopupComponent,
        TimeOffFilterPanelComponent
    ],
  templateUrl: './absences.component.html'
})
export class AbsencesComponent extends TimeOffRequestsComponent<LeaveOfAbsenceGridViewDto> implements OnChanges {
    constructor() {
        super();
        this.init(LeaveOfAbsenceGridViewDto);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['employeeId']) {
            this.dataSource = this.dataSources.leaveOfAbsences(this.employeeId);
        }
    }

    dataSource = this.dataSources.leaveOfAbsences(null);
    filterModel: LeaveOfAbsenceGridViewDto = new LeaveOfAbsenceGridViewDto();
    gridFieldName = (name: keyof LeaveOfAbsenceGridViewDto): string => name;
    filterModelName = (name: keyof LeaveOfAbsenceGridViewDto): string => name;
    protected override exportName: string = "Absences";
    protected tabName = 'absence';

    getCellData(cellInfo: { data: LeaveOfAbsenceGridViewDto }) {
        return cellInfo.data;
    }

}
